export default {
	localLibraryName: 'ordabanki-local-library',

	pageSize: 50,

	//apiRoot: 'http://130.208.108.18:8800'
	apiRoot: 'https://idord.arnastofnun.is/d',
	//apiRoot: '/d',

	gaTrackingId: 'G-LFGXPPXXZR'
}



// WEBPACK FOOTER //
// ./src/config.js